<template>
  <el-container>
    <el-dialog
      class="data-source-modal-body"
      title="引用"
      center
      :visible.sync="quoteDialog.dialogVisible"
      :close-on-click-modal="false"
      width="670px">
      <div class="el-dialog-table" v-loading="quoteDialog.loading"
         element-loading-spinner="el-icon-loading"
         element-loading-text="正在加载，请稍等">
         <el-table v-if="quoteDialog.tableData.length"
         :data="quoteDialog.tableData"
         height="230px"
         header-row-class-name="header-class">
            <el-table-column prop="name"
                             label="名称"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                             prop="type"
                             label="引用类型"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="createTime"
                             label="创建时间"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
          </el-table>
          <div v-else class="no-list">
            <img src="@/globalComponent/calculation/assets/nothing.png" alt="无内容">
            <p>暂无引用记录</p>
          </div>
      </div>
      <span v-if="quoteDialog.type==='delete'" slot="footer" class="dialog-footer">
        <div class="tips"><span>你确认删除吗?</span></div>
        <el-button type="primary" @click="sure">确定</el-button>
        <el-button @click="quoteDialog.dialogVisible = false">取消</el-button>
      </span>
      <span v-else slot="footer" class="dialog-footer">
        <el-button @click="quoteDialog.dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

  </el-container>
</template>

<script>

export default {
  name: 'QuoteReportDialog',
  props: ['quoteDialog'],
  data () {
    return {
      loading: false
    }
  },
  methods: {
    sure () {
      this.quoteDialog.dialogVisible = false
      this.$emit('delete', this.quoteDialog.rowId)
    }
  }
}
</script>

<style lang="scss">
  .data-source-modal-body {
   .el-dialog--center .el-dialog__body {
     padding: 14px 24px;
     .el-dialog-table {
       .el-icon-loading {
         font-size: 36px;
         color: #AAAEB5;
       }
       .el-loading-text {
         color: #999999;
       }
      .no-list {
        margin: 0 auto 0;
        text-align: center;
        color: #999999;
        font-size: 12px;
        height: 230px;
        padding-top: 70px;
      }
     }
   }
   .el-dialog__footer{
     padding-top: 0;
     .dialog-footer{
       button {
         width: 82px;
         height: 26px;
         line-height: 26px;
         padding: 0;
         &:nth-child(2){
           margin-left: 40px;
         }
       }
       .tips {
         margin-bottom: 10px;
         span {
           color: red;
         }
       }
     }
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/report/design/quote-report-dialog.vue